import { render, staticRenderFns } from "./ClientAddressItem.vue?vue&type=template&id=215676f6&"
import script from "./ClientAddressItem.vue?vue&type=script&lang=js&"
export * from "./ClientAddressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports